module.exports = __webpack_public_path__ + "img/icon-speed-2.c3a77758.svg";